import type { MessageKey } from 'modules/intl';

type SectionTitle = 'hero' | 'caseStudies' | 'services' | 'offices' | 'inquiry' | 'principles' | 'gallery' | 'development' | 'numbers' | 'testimonials' | 'leadership' | 'mission' | 'values' | 'vision' | 'wrote' | 'workshop' | 'workshopProcess' | 'buzzwords' | 'quote' | 'process' | 'technologies' | 'blogPosts' | 'why' | 'footer' | 'career'

export const sectionTitles = {
    hero: {
        homepage: 'sectionNavTitles.hero.homepage',
        aboutUsPage: 'sectionNavTitles.hero.aboutUsPage',
        analysisPage: 'sectionNavTitles.hero.analysisPage',
        appDevelopmentPage: 'sectionNavTitles.hero.appDevelopmentPage',
        mobileAppDevelopmentPage: 'sectionNavTitles.hero.mobileAppDevelopmentPage',
        webAppDevelopmentPage: 'sectionNavTitles.hero.webAppDevelopmentPage',
        general: 'sectionNavTitles.heroGeneral',
        berlin: '',
        prague: ''
    },
    caseStudies: {
        homepage: 'sectionNavTitles.caseStudies.homepage',
        aboutUsPage: 'sectionNavTitles.caseStudies.aboutUsPage',
        appDevelopmentPage: 'sectionNavTitles.caseStudies.appDevelopmentPage',
        mobileAppDevelopmentPage: 'sectionNavTitles.caseStudies.mobileAppDevelopmentPage',
        webAppDevelopmentPage: 'sectionNavTitles.caseStudies.webAppDevelopmentPage',
        analysisPage: '',
        berlin: '',
        prague: '',
        general: ''
    },
    services: {
        homepage: 'sectionNavTitles.services.homepage',
        aboutUsPage: 'sectionNavTitles.services.aboutUsPage',
        appDevelopmentPage: 'sectionNavTitles.services.appDevelopmentPage',
        mobileAppDevelopmentPage: 'sectionNavTitles.services.mobileAppDevelopmentPage',
        webAppDevelopmentPage: 'sectionNavTitles.services.webAppDevelopmentPage',
        berlin: 'sectionNavTitles.services.berlin',
        analysisPage: '',
        prague: '',
        general: ''
    },
    offices: {
        homepage: 'sectionNavTitles.offices.homepage',
        aboutUsPage: 'sectionNavTitles.offices.aboutUsPage',
        analysisPage: 'sectionNavTitles.offices.analysisPage',
        appDevelopmentPage: 'sectionNavTitles.offices.appDevelopmentPage',
        mobileAppDevelopmentPage: 'sectionNavTitles.offices.mobileAppDevelopmentPage',
        webAppDevelopmentPage: 'sectionNavTitles.offices.webAppDevelopmentPage',
        berlin: 'sectionNavTitles.offices.berlin',
        prague: 'sectionNavTitles.offices.prague',
        design: 'sectionNavTitles.offices.design',
    },
    inquiry: {
        homepage: 'sectionNavTitles.inquiry.homepage',
        aboutUsPage: 'sectionNavTitles.inquiry.aboutUsPage',
        analysisPage: 'sectionNavTitles.inquiry.analysisPage',
        appDevelopmentPage: 'sectionNavTitles.inquiry.appDevelopmentPage',
        mobileAppDevelopmentPage: 'sectionNavTitles.inquiry.mobileAppDevelopmentPage',
        webAppDevelopmentPage: 'sectionNavTitles.inquiry.webAppDevelopmentPage',
        berlin: '',
        prague: '',
        general: ''
    },
    principles: {
        design: 'sectionNavTitles.principles.design',
    },
    gallery: {
        berlin: 'sectionNavTitles.gallery.berlin',
        prague: 'sectionNavTitles.gallery.prague',
        homepage: '',
        aboutUsPage: '',
        analysisPage: '',
        appDevelopmentPage: '',
        mobileAppDevelopmentPage: '',
        webAppDevelopmentPage: '',
        general: ''
    },
    development: {
        mobile: 'sectionNavTitles.development.mobile',
        web: 'sectionNavTitles.development.web',
        design: 'sectionNavTitles.development.design',
        backend: 'sectionNavTitles.development.backend',
    },
    numbers: {
        aboutUsPage: 'sectionNavTitles.numbers.aboutUsPage',
        homepage: '',
        analysisPage: '',
        appDevelopmentPage: '',
        mobileAppDevelopmentPage: '',
        webAppDevelopmentPage: '',
        berlin: '',
        prague: '',
        general: ''
    },
    testimonials: {
        aboutUsPage: 'sectionNavTitles.testimonials.aboutUsPage',
        berlin: 'sectionNavTitles.testimonials.berlin',
        homepage: '',
        analysisPage: '',
        appDevelopmentPage: '',
        mobileAppDevelopmentPage: '',
        webAppDevelopmentPage: '',
        prague: '',
        general: ''
    },
    leadership: {
        aboutUsPage: 'sectionNavTitles.leadership.aboutUsPage',
        homepage: '',
        analysisPage: '',
        appDevelopmentPage: '',
        mobileAppDevelopmentPage: '',
        webAppDevelopmentPage: '',
        berlin: '',
        prague: '',
        general: ''
    },
    mission: {
        aboutUsPage: 'sectionNavTitles.mission.aboutUsPage',
        homepage: '',
        analysisPage: '',
        appDevelopmentPage: '',
        mobileAppDevelopmentPage: '',
        webAppDevelopmentPage: '',
        berlin: '',
        prague: '',
        general: ''
    },
    values: {
        aboutUsPage: 'sectionNavTitles.values.aboutUsPage',
        homepage: '',
        analysisPage: '',
        appDevelopmentPage: '',
        mobileAppDevelopmentPage: '',
        webAppDevelopmentPage: '',
        berlin: '',
        prague: '',
        general: ''
    },
    vision: {
        aboutUsPage: 'sectionNavTitles.vision.aboutUsPage',
        homepage: '',
        analysisPage: '',
        appDevelopmentPage: '',
        mobileAppDevelopmentPage: '',
        webAppDevelopmentPage: '',
        berlin: '',
        prague: '',
        general: ''
    },
    wrote: {
        aboutUsPage: 'sectionNavTitles.wrote.aboutUsPage',
        homepage: '',
        analysisPage: '',
        appDevelopmentPage: '',
        mobileAppDevelopmentPage: '',
        webAppDevelopmentPage: '',
        berlin: '',
        prague: '',
        general: ''
    },
    workshop: {
        analysisPage: 'sectionNavTitles.workshop.analysisPage',
        homepage: '',
        aboutUsPage: '',
        appDevelopmentPage: '',
        mobileAppDevelopmentPage: '',
        webAppDevelopmentPage: '',
        berlin: '',
        prague: '',
        general: ''
    },
    workshopProcess: {
        analysisPage: 'sectionNavTitles.workshopProcess.analysisPage',
        homepage: '',
        aboutUsPage: '',
        appDevelopmentPage: '',
        mobileAppDevelopmentPage: '',
        webAppDevelopmentPage: '',
        berlin: '',
        prague: '',
        general: ''
    },
    buzzwords: {
        analysisPage: 'sectionNavTitles.buzzwords.analysisPage',
        homepage: '',
        aboutUsPage: '',
        appDevelopmentPage: '',
        mobileAppDevelopmentPage: '',
        webAppDevelopmentPage: '',
        berlin: '',
        prague: '',
        general: ''
    },
    quote: {
        analysisPage: 'sectionNavTitles.quote.analysisPage',
        homepage: '',
        aboutUsPage: '',
        appDevelopmentPage: '',
        mobileAppDevelopmentPage: '',
        webAppDevelopmentPage: '',
        berlin: '',
        prague: '',
        general: ''
    },
    process: {
        appDevelopmentPage: 'sectionNavTitles.process.appDevelomentPage',
        design: 'sectionNavTitles.process.design',
    },
    technologies: {
        mobileAppDevelopmentPage: 'sectionNavTitles.technologies.mobileAppDevelopmentPage',
        webAppDevelopmentPage: 'sectionNavTitles.technologies.webAppDevelopmentPage',
        homepage: '',
        aboutUsPage: '',
        analysisPage: '',
        appDevelopmentPage: '',
        berlin: '',
        prague: '',
        general: ''
    },
    blogPosts: {
        mobileAppDevelopmentPage: 'sectionNavTitles.blogPosts.mobileAppDevelopmentPage',
        webAppDevelopmentPage: 'sectionNavTitles.blogPosts.webAppDevelopmentPage',
        homepage: '',
        aboutUsPage: '',
        analysisPage: '',
        appDevelopmentPage: '',
        berlin: '',
        prague: '',
        general: ''
    },
    why: {
        appDevelopmentPage: 'sectionNavTitles.why.appDevelomentPage',
        homepage: '',
        aboutUsPage: '',
        analysisPage: '',
        mobileAppDevelopmentPage: '',
        webAppDevelopmentPage: '',
        berlin: '',
        prague: '',
        general: ''
    },
    footer: 'sectionNavTitles.footer',
    career: {
        positions: 'sectionNavTitles.career.positions',
        gallery: 'sectionNavTitles.career.gallery',
    },
} as const satisfies Record<SectionTitle, Record<string, MessageKey | string> | MessageKey>;
